// extracted by mini-css-extract-plugin
export var dividerContainer = "_8x-0";
export var line = "_8x-1";